/*! <%= package.Cfg.name %> - v<%= package.Cfg.version %> - <%= package.Cfg.license %> */(function(angular){
    'use strict';

    var module = angular.module('internal.tools.validationUtils', []);

    var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

    // regex used by angular
    module.value('bmtEmailRegEx', EMAIL_REGEXP);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('internal.tools.validationUtils').directive('senderEmailValidator', ['bmtEmailRegEx', function(emailRegEx){
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attr, ngModel) {
                ngModel.$validators.senderEmail = function(value){
                    // optional - use required validator if value is required
                    if(ngModel.$isEmpty(value)){
                        return true;
                    }

                    // allow custom variables
                    if(value.length > 2 && value.indexOf('[') === 0 && value.indexOf(']') === value.length - 1){
                        return true;
                    }

                    return emailRegEx.test(value);
                };
            }
        };
    }]);
})(window.angular);

(function(jQuery){
    'use strict';

    jQuery.Editable.prototype.sanitizeURL = function(url){
        if(/^(https?:|ftps?:|)\/\//.test(url)){
            if(!this.isURL(url)){
                return '';
            }
        } else {
          // allow brackets with spaces for custom variables
          url = url.replace(/%5B/g, '[').replace(/%5D/g, ']');

          if(url.indexOf('[') === 0 && url.indexOf(']') === url.length - 1){
            return url;
          }

          // normal froala encoding
          url = encodeURIComponent(url)
                .replace(/%23/g, '#')
                .replace(/%2F/g, '/')
                .replace(/%25/g, '%')
                .replace(/mailto%3A/g, 'mailto:')
                .replace(/tel%3A/g, 'tel:')
                .replace(/data%3Aimage/g, 'data:image')
                .replace(/webkit-fake-url%3A/g, 'webkit-fake-url:')
                .replace(/%3F/g, '?')
                .replace(/%3D/g, '=')
                .replace(/%26/g, '&')
                .replace(/&amp;/g, '&')
                .replace(/%2C/g, ',')
                .replace(/%3B/g, ';')
                .replace(/%2B/g, '+')
                .replace(/%40/g, '@');
        }

        return url;
    };
})(window.jQuery);

(function(angular){
    'use strict';

    angular.module('internal.tools.clientNotifications', [
        'pascalprecht.translate',
        'bluemoon.components.Notifications',
        'bluemoon.components.util',
        'bmFileReader',
        'bmFroala',
        'internal.tools.validationUtils'
    ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('internal.tools.clientNotifications').directive('bmtEmailListFormatter', [function(){
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attr, ngModel){
                element.bind('blur', function(){
                    var value = ngModel.$modelValue;
                    var emailRegEx = /([a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+)/gi;

                    if(ngModel.$isEmpty(value)){
                        return;
                    }

                    var parsedEmailList = '';
                    var validEmails = value.match(emailRegEx);

                    if(validEmails && validEmails.length > 0){
                        parsedEmailList = validEmails.join(',');
                    }

                    ngModel.$setViewValue(parsedEmailList);
                    element[0].value = parsedEmailList;
                });
            }
        };
    }]);
})(window.angular);

(function(angular){
    'use strict';

     angular.module('internal.tools.clientNotifications').factory('messageFactory', messageFactory);
     messageFactory.$inject = ['$q', '$http', 'bmLanguageManager', 'bmHttpCacheHelper'];

     function messageFactory($q, $http, bmLanguageManager, bmHttpCacheHelper){
        var factory = {
            saveCategory: saveCategory,
            deleteCategory: deleteCategory,
            getCategories: getCategories,
            getCategoriesWithTypes: getCategoriesWithTypes,
            getCategoryById: getCategoryById,
            getLanguageList: getLanguageList,
            getNotificationsForCategory: getNotificationsForCategory,
            getNotificationTypeById: getNotificationTypeById,
            saveNotificationType: saveNotificationType,
            deleteNotificationType: deleteNotificationType,
            getTemplatesForType: getTemplatesForType,
            getTemplateAssociationsByVariable: getTemplateAssociationsByVariable,
            getDefaultTemplateForType: getDefaultTemplateForType,
            getDefaultTemplateForTypeByCategory: getDefaultTemplateForTypeByCategory,
            saveNotificationTemplate: saveNotificationTemplate,
            cleanLocalizedNames: cleanLocalizedNames,
            getAllVariables: getAllVariables,
            saveVariable: saveVariable,
            deleteVariable: deleteVariable,
            sendTestEmail: sendTestEmail,
            getImagesApiForEnvironment: getImagesApiForEnvironment,
            deleteImage: deleteImage,
            importTemplates: importTemplates,
            exportTemplates: exportTemplates,
            importTranslation: importTranslation,
            exportTranslation: exportTranslation,
            exportTemplateCategories: exportTemplateCategories
        };

        var internalTemplateApiV1 = '/api/tools/v1/templates';
        var internalTemplateApiV2 = '/api/tools/v2/templates';

        var internalCategoriesApi = internalTemplateApiV1 + '/categories';
        var externalCategoriesApi = internalCategoriesApi.replace('tools', 'notifications');

        var internalVariablesApiV1 = internalTemplateApiV1 + '/variables';
        var internalVariablesApiV2 = internalTemplateApiV2 + '/variables';
        var externalVariablesApi = internalVariablesApiV1.replace('tools', 'notifications');

        var externalImagesApi = '/api/notifications/v1/templates/images';
        var internalImagesApi = '/api/tools/v1/templates/images';

        var externalDeleteImagesApi = externalImagesApi + '/delete/';
        var internalDeleteImagesApi = internalImagesApi + '/delete/';

        var languageDeferred;

        // init the language list
        getLanguageList();

        return factory;

        //////////

        function getLanguageList(){
            if(angular.isDefined(languageDeferred)){
                return languageDeferred.promise;
            }

            languageDeferred = $q.defer();

            bmLanguageManager.getLanguagesAsync(true).then(function(languages){
                languageDeferred.resolve(languages);
            });

            return languageDeferred.promise;
        }

        // clean up names array for passing to web service
        function cleanLocalizedNames(names){
            if(angular.isUndefined(names) || names.length === 0){
                return names;
            }

            return names.filter(function(value){
                var name = value.name;
                var description = value.description;

                // are both fields empty
                if((angular.isUndefined(name) || name === '') && (angular.isUndefined(description) || description === '')){
                    return false;
                }

                return true;
            });
        }

        // category methods
        function saveCategory(category){
            if(angular.isUndefined(category)){
                return deferredReject();
            }

            var method = 'POST';
            var url = internalCategoriesApi;

            if(angular.isDefined(category.id)){
                method = 'PUT';
                url = url + '/' + category.id;
            }

            var httpConfig = {
                method: method,
                url: url,
                data: category
            };

            return $http(httpConfig).then(function(response){
                return response.data;
            });
        }

        function deleteCategory(category){
            if(angular.isUndefined(category) || angular.isUndefined(category.id)){
                return deferredReject();
            }

            var httpConfig = {
                method: 'DELETE',
                url: internalCategoriesApi + '/' + category.id
            };

            return $http(httpConfig);
        }

        function getCategories(environment, includeTypes){
            var api = internalCategoriesApi;

            if(angular.isDefined(environment) && environment !== 'internal'){
                api = externalCategoriesApi;
            }

            if(includeTypes){
                api = api + '?expand=true';
            }

            var httpConfig = {
                method: 'GET',
                url: api
            };

            return $http(httpConfig).then(function(response){
                return response.data;
            });
        }

        function getCategoriesWithTypes(environment){
            if(angular.isUndefined(environment) || environment === ''){
                environment = 'internal';
            }

            return getCategories(environment, true);
        }

        function getCategoryById(id){
            var deferred = $q.defer();

            if(angular.isUndefined(id) || id === ''){
                deferred.resolve();
                return deferred.promise;
            }

            // TODO: THIS COULD BE MORE PERFORMANT IF WEB SERVICES SUPPORTED GETTING CATEGORY BY ID
            return getCategories().then(function(categories){
                if(angular.isUndefined(categories)){
                    deferred.resolve();
                    return deferred.promise;
                }

                var categoryArr = categories.filter(function(value){
                    return value.id === id;
                });

                if(angular.isDefined(categoryArr) && categoryArr.length === 1){
                    return categoryArr[0];
                }

                deferred.resolve();
                return deferred.promise;
            });
        }

        // notification methods
        function saveNotificationType(notificationType, categoryId){
            if(angular.isUndefined(categoryId)){
                return deferredReject();
            }

            var method = 'POST';
            var url = internalCategoriesApi + '/' + categoryId + '/types';

            if(angular.isDefined(notificationType.id)){
                method = 'PUT';
                url = url + '/' + notificationType.id;
            }

            var httpConfig = {
                method: method,
                url: url,
                data: notificationType
            };

            return $http(httpConfig).then(function(response){
                return response.data;
            });
        }

        function deleteNotificationType(notificationType){
            if(angular.isUndefined(notificationType) || angular.isUndefined(notificationType.categoryId) || angular.isUndefined(notificationType.id)){
                return deferredReject();
            }

            var httpConfig = {
                method: 'DELETE',
                url: internalCategoriesApi + '/' + notificationType.categoryId + '/types/' + notificationType.id
            };

            return $http(httpConfig);
        }

        function getNotificationsForCategory(categoryId){
            if(angular.isUndefined(categoryId)){
                return deferredReject();
            }

            var httpConfig = {
                method: 'GET',
                url: internalCategoriesApi + '/' + categoryId + '/types'
            };

            return $http(httpConfig).then(function(response){
                return response.data;
            });
        }

        function getNotificationTypeById(typeId, categoryId){
            if(angular.isUndefined(typeId) || angular.isUndefined(categoryId)){
                return deferredReject();
            }

            // TODO: THIS COULD BE MORE PERFORMANT IF WEB SERVICES SUPPORTED GETTING TYPE BY ID
            return getNotificationsForCategory(categoryId).then(function(notificationTypes){
                if(angular.isUndefined(notificationTypes) || notificationTypes.length === 0){
                    return deferredReject();
                }

                var typeArr = notificationTypes.filter(function(value){
                    return value.id === typeId;
                });

                if(angular.isDefined(typeArr) && typeArr.length === 1){
                    return typeArr[0];
                }

                var deferred = $q.defer();
                deferred.resolve();
                return deferred.promise;
            });
        }

        // template methods
        function getDefaultTemplateForTypeByCategory(typeId, categoryId, locale){
            return getNotificationTypeById(typeId, categoryId).then(function(notificationType){
                return getDefaultTemplateForType(notificationType, locale);
            });
        }

        function getDefaultTemplateForType(notificationType, locale){
            if(angular.isUndefined(notificationType)){
                return deferredReject();
            }

            return getTemplatesForType(notificationType.categoryCode, notificationType.code, locale, 'internal').then(function(templates){
                if(angular.isDefined(templates) && angular.isDefined(templates.defaultTemplate)){
                    return templates.defaultTemplate;
                }

                return deferredReject();
            });
        }

        function getTemplatesForType(categoryCode, typeCode, locale, environment){
            if(angular.isUndefined(categoryCode) || categoryCode === ''){
                return deferredReject();
            }

            if(angular.isUndefined(typeCode) || typeCode === ''){
                return deferredReject();
            }

            if(angular.isUndefined(locale)){
                locale = bmLanguageManager.getCurrentLanguage();
            }

            var api = internalCategoriesApi + '/' + categoryCode + '/types/' + typeCode + '/templates?locale=' + locale;

            if(angular.isDefined(environment) && environment !== 'internal'){
                api = api.replace(internalCategoriesApi, externalCategoriesApi);
            }

            // TODO: MAY NEED TO URL ENCODE TYPE HERE
            var httpConfig = {
                method: 'GET',
                url: api
            };

            return $http(httpConfig).then(function(response){
                return response.data;
            });
        }

        function getTemplateAssociationsByVariable(variable){
            var api = internalVariablesApiV2 + '/template-associations/' + variable.id;

            // cache for 10 minutes
            var httpConfig = {
                method: 'GET',
                url: api,
                bmCache: 600000,
            };

            return $http(httpConfig).then(function(response){
                return response.data;
            });
        }

        function saveNotificationTemplate(template){
            if(angular.isUndefined(template) || angular.isUndefined(template.type) || angular.isUndefined(template.type.code)){
                return deferredReject();
            }

            var method = 'POST';
            var baseUrl = angular.isDefined(template.environment) && template.environment === 'internal' ? internalCategoriesApi : externalCategoriesApi;
            var url = baseUrl + '/' + template.type.categoryCode + '/types/' + template.type.code + '/templates';

            if(angular.isDefined(template.id)){
                method = 'PUT';
                url = url + '/' + template.id;
            }

            var httpConfig = {
                method: method,
                url: url,
                data: template
            };

            return $http(httpConfig).then(function(response){
                return response.data;
            });
        }

        function getAllVariables(){
            var api = internalVariablesApiV2;

            var httpConfig = {
                method: 'GET',
                url: api
            };

            return $http(httpConfig).then(function(response){
                return response.data;
            });
        }

        function saveVariable(variable){
            // TODO: WHAT IF THE CODE IS WHAT IS BEING CHANGED?
            if(angular.isUndefined(variable) || angular.isUndefined(variable.code)){
                return deferredReject();
            }

            var method = 'POST';
            var url = internalVariablesApiV1;

            if(angular.isDefined(variable.id)){
                method = 'PUT';
                url = url + '/' + variable.code;
            }

            var httpConfig = {
                method: method,
                url: url,
                data: variable
            };

            return $http(httpConfig).then(function(response){
                bmHttpCacheHelper.invalidateHttpCache(internalVariablesApiV1);
                bmHttpCacheHelper.invalidateHttpCache(externalVariablesApi);
                return response.data;
            });
        }

        function deleteVariable(variable){
            if(angular.isUndefined(variable) || angular.isUndefined(variable.id)){
                return deferredReject();
            }

            var httpConfig = {
                method: 'DELETE',
                url: internalVariablesApiV1 + '/' + variable.id
            };

            return $http(httpConfig).then(function(){
                bmHttpCacheHelper.invalidateHttpCache(internalVariablesApiV1);
                bmHttpCacheHelper.invalidateHttpCache(externalVariablesApi);
            });
        }

        function sendTestEmail(template){
            if(angular.isUndefined(template) || angular.isUndefined(template.type) || angular.isUndefined(template.type.code)){
                return deferredReject();
            }

            var isInternal = angular.isDefined(template.environment) && template.environment === 'internal';
            var baseUrl = isInternal ? internalCategoriesApi : externalCategoriesApi;
            var url = baseUrl + '/' + template.type.categoryCode + '/types/' + template.type.code + '/test';

            var httpConfig = {
                method: 'POST',
                url: url,
                data: template
            };

            // don't redirect to login page for internal tools
            if(isInternal){
                httpConfig.bmAuthRedirect = false;
            }

            return $http(httpConfig).then(function(response){
                return response.data;
            });
        }

        function deferredReject(){
            var deferred = $q.defer();
            deferred.reject();
            return deferred.promise;
        }

        function getImagesApiForEnvironment(environment){
            return (environment === 'internal') ? internalImagesApi : externalImagesApi;
        }

        function getDeleteImagesApiForEnvironment(environment){
            return (environment === 'internal') ? internalDeleteImagesApi : externalDeleteImagesApi;
        }

        function deleteImage(imageId, environment){
            if(angular.isUndefined(imageId) || imageId === ''){
                var deferred = $q.defer();
                deferred.reject();
                return deferred.promise;
            }

            var api = getDeleteImagesApiForEnvironment(environment) + imageId;

            var config = {
                url: api,
                method: 'POST'
            };

            return $http(config);
        }

        function importTemplates(data){
            var api = '/api/tools/v1/templates/import';

            var config = {
                url: api,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                data: data,
                timeout: 120000 // 2 minutes
            };

            return $http(config);
        }

        function importTranslation(data){
            var api = '/api/tools/v1/templates/import-translation';

            var config = {
                url: api,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                data: data,
                timeout: 120000 // 2 minutes
            };

            return $http(config);
        }

        function exportTemplates(){
            var api = '/api/tools/v1/templates/export';

            var config = {
                url: api,
                method: 'GET',
                headers: { 'Accept': 'application/json' },
                timeout: 120000 // 2 minutes
            };

            return $http(config);
        }

        function exportTranslation(){
            var api = '/api/tools/v1/templates/export-translation';

            var config = {
                url: api,
                method: 'GET',
                headers: { 'Accept': 'application/json' },
                timeout: 120000 // 2 minutes
            };

            return $http(config);
        }

        function exportTemplateCategories(categories){

            var params = 'includeVariables=true&categories=';
            angular.forEach(categories, function(category){
                params += category + ',';
            });
            // Remove the trailing comma
            params = params.replace(/,$/, '');

            var api = '/api/tools/v1/templates/export?' + params;

            var config = {
                url: api,
                method: 'GET',
                headers: { 'Accept': 'application/json' },
                timeout: 120000 // 2 minutes
            };

            return $http(config);
        }

     }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('internal.tools.clientNotifications').factory('LocalizedName', localizedName);
    localizedName.$inject = [];

    function localizedName(){
        function LocalizedName(data){
            var self = this;

            // properties
            self.locale = data.locale;
            self.name = data.name;
            self.description = data.description;

            if(angular.isDefined(data) && angular.isDefined(data.id)){
                self.id = data.id;
            }
        }

        return LocalizedName;
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('internal.tools.clientNotifications').factory('bmtClientNotificationPreferences', preferences);
    preferences.$inject = [];

    function preferences(){
        function ClientNotificationPreferences(data){
            /*jshint validthis:true */
            var self = this;
            var defaultData = {
                locale: '',
                senderName: '',
                senderEmail: '',
                cc: '',
                bcc: '',
                headerText: '',
                footerText: ''
            };

            if(angular.isUndefined(data)){
                angular.extend(self, defaultData);
                return;
            }

            // set defaults
            self.locale = angular.isUndefined(data.locale) ? defaultData.locale : data.locale;
            self.senderName = angular.isUndefined(data.senderName) ? defaultData.senderName : data.senderName;
            self.senderEmail = angular.isUndefined(data.senderEmail) ? defaultData.senderEmail : data.senderEmail;
            self.cc = angular.isUndefined(data.cc) ? defaultData.cc : data.cc;
            self.bcc = angular.isUndefined(data.bcc) ? defaultData.bcc : data.bcc;
            self.headerText = angular.isUndefined(data.headerText) ? defaultData.headerText : data.headerText;
            self.footerText = angular.isUndefined(data.footerText) ? defaultData.footerText : data.footerText;
        }

        return ClientNotificationPreferences;
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('internal.tools.clientNotifications').factory('Variable', variable);
    variable.$inject = ['messageFactory', 'LocalizedName'];

    function variable(messageFactory, LocalizedName){
        function Variable(data){
            var self = this;

            updateSelf(data);

            init();

            //////////

            function updateSelf(data){
                if(angular.isUndefined(data)){
                    data = {};
                }

                // properties
                self.code = data.code;
                self.mandatory = data.mandatory;
                self.names = angular.isUndefined(data.names) ? [] : data.names;

                if(angular.isDefined(data.id)){
                    self.id = data.id;
                }

                self.save = saveVariable;
                self.delete = deleteVariable;
            }

            function init(){
                var names = angular.copy(self.names);
                var found = false;

                // TODO: BETTER WAY TO WRITE THIS
                messageFactory.getLanguageList().then(function(languages){
                    for(var i = 0; i < languages.length; i++){
                        found = false;

                        for(var j = 0; j < names.length; j++){
                            if(languages[i].code === names[j].locale){
                                found = true;
                                break;
                            }
                        }

                        if(!found){
                            self.names.push(new LocalizedName({ locale: languages[i].code }));
                        }
                    }
                });
            }

            function saveVariable(){
                /*jshint validthis:true */
                updateSelf(this);

                return messageFactory.saveVariable(this).then(function(savedVariable){
                    updateSelf(savedVariable);
                    return savedVariable;
                });
            }

            function deleteVariable(){
                return messageFactory.deleteVariable(self);
            }
        }

        return Variable;
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('internal.tools.clientNotifications').factory('NotificationType', notificationType);
    notificationType.$inject = ['$translate', 'messageFactory', 'LocalizedName', 'CleanNotificationType'];

    function notificationType($translate, messageFactory, LocalizedName, CleanNotificationType){
        function NotificationType(data, categoryId){
            var self = this;
            var actionUrlText = '';

            updateSelf(data, categoryId);

            $translate('bmt.notificationType.actionUrlText').then(function(value){
                actionUrlText = value;
                self.actionUrlText = angular.isUndefined(self.id) ? '' : value;
            });

            // methods
            self.save = saveType;
            self.delete = deleteType;

            init();

            //////////

            function updateSelf(typeData, categoryId){
                if(angular.isUndefined(typeData)){
                    typeData = {};
                    setEnablementDefaults();
                } else {
                    self.visible = typeData.visible;
                    self.disableSenderName = typeData.disableSenderName;
                    self.disableSenderEmail = typeData.disableSenderEmail;
                    self.disableCC = typeData.disableCC;
                    self.disableBCC = typeData.disableBCC;
                    self.disableSubjectLine = typeData.disableSubjectLine;
                    self.disableBody = typeData.disableBody;
                    self.disableUseGlobal = typeData.disableUseGlobal;
                    self.disableTask = typeData.disableTask;
                    self.disableEmailChannel = typeData.disableEmailChannel;
                    self.disableDirectChannel = typeData.disableDirectChannel;
                    self.disableMobileChannel = typeData.disableMobileChannel;
                    self.disableDirectAllowed = typeData.disableDirectAllowed;
                    self.disableEmailAllowed = typeData.disableEmailAllowed;
                    self.disableMobileAllowed = typeData.disableMobileAllowed;
                    self.disableDigestFrequency = typeData.disableDigestFrequency;
                    self.disableDigestSubject = typeData.disableDigestSubject;
                    self.disableDigestHeader = typeData.disableDigestHeader;
                    self.disableDigestFooter = typeData.disableDigestFooter;
                    self.mobileDestination = typeData.mobileDestination;
                    self.digestable = typeData.digestable;
                    self.includeHeader = typeData.includeHeader;
                    self.includeFooter = typeData.includeFooter;
                    self.includeGlobalVariables = typeData.includeGlobalVariables;
                }

                if(angular.isDefined(typeData.id)){
                    self.id = typeData.id;
                }

                // keep current categoryId if passed
                if(angular.isDefined(categoryId)){
                    self.categoryId = categoryId;
                } else if(angular.isUndefined(self.categoryId)){
                    self.categoryId = typeData.categoryId;
                }

                self.code = typeData.code;
                self.feature = typeData.feature;
                self.resource = typeData.resource;
                self.names = angular.isUndefined(typeData.names) ? [] : typeData.names;
                self.variables = angular.isUndefined(typeData.variables) ? [] : typeData.variables;

                self.actionUrl = angular.isUndefined(self.id) ? '' : '#/notification-default-templates/' + self.categoryId + '/' + self.id;
                self.actionUrlText = angular.isUndefined(self.id) ? '' : actionUrlText;
            }

            function init(){
                var names = angular.copy(self.names);
                var found = false;

                messageFactory.getLanguageList().then(function(languages){
                    for(var i = 0; i < languages.length; i++){
                        found = false;

                        for(var j = 0; j < names.length; j++){
                            if(languages[i].code === names[j].locale){
                                found = true;
                                break;
                            }
                        }

                        if(!found){
                            self.names.push(new LocalizedName({ locale: languages[i].code }));
                        }
                    }
                });
            }

            function saveType(){
                /*jshint validthis:true */
                updateSelf(this);
                return messageFactory.saveNotificationType(new CleanNotificationType(self), self.categoryId).then(function(savedTyped){
                    updateSelf(savedTyped);
                });
            }

            function deleteType(){
                return messageFactory.deleteNotificationType(self);
            }

            function setEnablementDefaults(){
                self.visible = true;
                self.disableSenderName = false;
                self.disableSenderEmail = false;
                self.disableCC = false;
                self.disableBCC = false;
                self.disableSubjectLine = false;
                self.disableBody = false;
                self.disableUseGlobal = false;
                self.disableTask = false;
                self.disableEmailChannel = false;
                self.disableDirectChannel = false;
                self.disableMobileChannel = false;
                self.disableDirectAllowed = false;
                self.disableEmailAllowed = false;
                self.disableMobileAllowed = false;
                self.disableDigestFrequency = true;
                self.disableDigestSubject = true;
                self.disableDigestHeader = true;
                self.disableDigestFooter = true;
                self.digestable = false;
                self.includeHeader = true;
                self.includeFooter = true;
                self.includeGlobalVariables = true;
            }
        }

        return NotificationType;
    }

    //////////

    angular.module('internal.tools.clientNotifications').factory('CleanNotificationType', cleanNotificationType);
    cleanNotificationType.$inject = ['messageFactory'];

    function cleanNotificationType(messageFactory){
        function CleanNotificationType(data){
            var self = this;

            if(angular.isDefined(data.id)){
                self.id = data.id;
            }

            self.code = data.code;
            self.feature = data.feature;
            self.resource = data.resource;
            self.mobileDestination = data.mobileDestination;
            self.names = messageFactory.cleanLocalizedNames(data.names);
            self.variables = data.variables;

            if(angular.isDefined(self.variables) && self.variables.length !== 0){
                angular.forEach(self.variables, function(variable){
                    variable.names = messageFactory.cleanLocalizedNames(variable.names);
                });
            }

            self.visible = data.visible;
            self.disableSenderName = data.disableSenderName;
            self.disableSenderEmail = data.disableSenderEmail;
            self.disableCC = data.disableCC;
            self.disableBCC = data.disableBCC;
            self.disableSubjectLine = data.disableSubjectLine;
            self.disableBody = data.disableBody;
            self.disableUseGlobal = data.disableUseGlobal;
            self.disableTask = data.disableTask;
            self.disableEmailChannel = data.disableEmailChannel;
            self.disableDirectChannel = data.disableDirectChannel;
            self.disableMobileChannel = data.disableMobileChannel;
            self.disableDirectAllowed = data.disableDirectAllowed;
            self.disableEmailAllowed = data.disableEmailAllowed;
            self.disableMobileAllowed = data.disableMobileAllowed;
            self.disableDigestFrequency = data.disableDigestFrequency;
            self.disableDigestSubject = data.disableDigestSubject;
            self.disableDigestHeader = data.disableDigestHeader;
            self.disableDigestFooter = data.disableDigestFooter;
            self.digestable = data.digestable;
            self.includeHeader = data.includeHeader;
            self.includeFooter = data.includeFooter;
            self.includeGlobalVariables = data.includeGlobalVariables;
        }

        return CleanNotificationType;
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('internal.tools.clientNotifications').factory('TemplateChannel', templateChannel);

    function templateChannel(){
        function TemplateChannel(data){
            var self = this;

            // properties
            self.method = data.method;
            self.subject = data.subject;
            self.body = data.body;

            if(angular.isDefined(data) && angular.isDefined(data.id)){
                self.id = data.id;
            }
        }

        return TemplateChannel;
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('internal.tools.clientNotifications').factory('TemplateDigestChannel', templateDigestChannel);

    function templateDigestChannel(){
        function TemplateDigestChannel(data){
            var self = this;

            // properties
            self.channel = 'email';
            self.subject = data.subject;
            self.header = data.header;
            self.footer = data.footer;
            self.frequency = angular.isDefined(data.frequency) ? data.frequency : 'OFF';

            if(angular.isDefined(data) && angular.isDefined(data.id)){
                self.id = data.id;
            }
        }

        return TemplateDigestChannel;
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('internal.tools.clientNotifications').factory('NotificationTemplate', notificationTemplate);
    notificationTemplate.$inject = ['messageFactory', 'TemplateChannel', 'TemplateDigestChannel'];

    function notificationTemplate(messageFactory, TemplateChannel, TemplateDigestChannel){
        function NotificationTemplate(templateData){
            var self = this;

            updateSelf(templateData);

            // methods
            self.save = saveTemplate;
            self.delete = deleteTemplate;
            self.sendTest = testTemplate;

            //////////

            function updateSelf(template){
                if(angular.isUndefined(template)){
                    template = {};
                }

                if(angular.isDefined(template.id)){
                    self.id = template.id;
                }

                self.environment = angular.isDefined(template.environment) && template.environment !== '' ? template.environment : 'internal';
                self.language = template.language;
                self.senderName = template.senderName;
                self.senderEmail = template.senderEmail;
                self.cc = template.cc;
                self.bcc = template.bcc;
                self.useGlobal = template.useGlobal;

                self.sendEmail = template.sendEmail;
                self.sendDirect = template.sendDirect;
                self.sendMobile = template.sendMobile;
                self.disableDirectAllowed = template.disableDirectAllowed;
                self.disableEmailAllowed = template.disableEmailAllowed;
                self.disableMobileAllowed = template.disableMobileAllowed;

                self.mobileDestination = template.mobileDestination;

                self.channels = getCompleteChannelList(template.channels);
                self.digestChannels = getDigestChannel(template.digestChannels);
                self.type = template.type;
            }

            function saveTemplate(){
                /*jshint validthis:true */
                updateSelf(this);
                return messageFactory.saveNotificationTemplate(self).then(function(savedTemplate){
                    updateSelf(savedTemplate);
                });
            }

            function deleteTemplate(){
                return messageFactory.deleteNotificationTemplate(self);
            }

            function getCompleteChannelList(channels){
                if(angular.isUndefined(channels) || channels.length === 0){
                    return getDefaultChannels();
                }

                var completeChannels = [];

                // email
                var email = channels.filter(function(element){
                    return element.method === 'email';
                });

                var direct = channels.filter(function(element){
                    return element.method === 'direct';
                });

                var mobile = channels.filter(function(element){
                    return element.method === 'mobile';
                });

                completeChannels.push(angular.isUndefined(email) ? new TemplateChannel({ method: 'email' }) : email[0]);
                completeChannels.push(angular.isUndefined(direct) ? new TemplateChannel({ method: 'direct' }) : direct[0]);
                completeChannels.push(angular.isUndefined(mobile) ? new TemplateChannel({ method: 'mobile' }) : mobile[0]);

                return completeChannels;
            }

            function getDefaultChannels(){
                return [
                    new TemplateChannel({ method: 'email' }),
                    new TemplateChannel({ method: 'direct' }),
                    new TemplateChannel({ method: 'mobile' })
                ];
            }

            function getDigestChannel(digestChannels){
                if(angular.isUndefined(digestChannels) || digestChannels.length == 0){
                    return [ new TemplateDigestChannel({}) ];
                } else {
                    return digestChannels;
                }
            }

            function testTemplate(){
                /*jshint validthis:true */
                updateSelf(this);
                return messageFactory.sendTestEmail(self).then(function(){
                });
            }
        }

        return NotificationTemplate;
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('internal.tools.clientNotifications').factory('bmtClientNotificationsStylingManager', stylingManager);
    stylingManager.$inject = ['$q', '$http', 'bmHttpCacheHelper'];

    function stylingManager($q, $http, bmHttpCacheHelper){
        var factory = {
            getLocalePreferences: getLocalePreferences,
            saveNotificationPreferences: saveNotificationPreferences
        };

        var externalApi = '/api/notifications/v1/templates/preferences';
        var internalApi = '/api/tools/v1/templates/preferences';

        return factory;

        ///////////

        function getGlobalLocalePreferences(locale){
            return getPreferences(locale, internalApi);
        }

        function getLocalePreferences(environment, locale){
            if(environment === 'internal'){
                return getGlobalLocalePreferences(locale);
            }

            return getPreferences(locale, externalApi);
        }

        function getPreferences(locale, api){
            if(angular.isUndefined(locale) || locale === ''){
                var deferred = $q.defer();
                deferred.reject();
                return deferred.promise;
            }

            // cache for 10 minutes
            var config = {
                url: api + '?locale=' + locale,
                method: 'GET',
                bmCache: 600000
            };

            return $http(config).then(function(response){
                return response.data;
            });
        }

        function saveGlobalLocalPreferences(preference){
            return savePreferences(preference, internalApi);
        }

        function saveNotificationPreferences(environment, preference){
            if(environment === 'internal'){
                return saveGlobalLocalPreferences(preference);
            }

            return savePreferences(preference, externalApi);
        }

        function savePreferences(preference, api){
            if(angular.isUndefined(preference) || angular.isUndefined(preference.locale) || preference.locale === ''){
                var deferred = $q.defer();
                deferred.reject();
                return deferred.promise;
            }

            var config = {
                url: api,
                method: 'PUT',
                data: preference
            };

            return $http(config).then(function(response){
                bmHttpCacheHelper.invalidateHttpCache(api + '?locale=' + preference.locale);
                return response.data;
            });
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('internal.tools.clientNotifications').controller('bmtClientNotificationsStyling', stylingController);
    stylingController.$inject = [
        '$q',
        '$scope',
        '$translate',
        '$uibModal',
        'bmtClientNotificationsStylingManager',
        'bmtClientNotificationPreferences',
        'bluemoon.components.Notifications',
        'messageFactory',
        'bmUtil'
    ];

    function stylingController($q, $scope, $translate, $uibModal, stylingManger, ClientNotificationPreferences, Notifications, messageFactory, bmUtil){
        /*jshint validthis:true */
        this.$onInit = function() {
            var vm = this;
            var currentPreferences;

            // vm.environment - attribute bound to determine internal versus external tools
            if(angular.isUndefined(vm.environment) || vm.environment === ''){
                vm.environment = 'external';
            }

            vm.displayIsGood = false;
            vm.allowSampleText = false;
            vm.saveStyle = saveStyle;
            vm.resetStyle = resetStyle;
            vm.openRestoreStyle = openRestoreStyle;
            vm.clearHeaderText = clearHeaderText;
            vm.clearFooterText = clearFooterText;

            vm.alerts = [];
            vm.openSampleTextModal = openSampleTextModal;

            // 2-way bound data object to pass information between tabs
            vm.languageLocal = vm.data;

            if(angular.isUndefined(vm.languageLocal) || angular.isUndefined(vm.languageLocal.code) || vm.languageLocal.code === ''){
                vm.languageLocal = { code: 'en-US'};
            }

            var imageUploadApi = messageFactory.getImagesApiForEnvironment(vm.environment);
            var onvioHeaders = {};
            var tokenType = 'UDSLongToken';
            var token = bmUtil.cookie(tokenType);
            var froalaImages = [];

            if(token){
                onvioHeaders.Authorization = tokenType + ' ' + token;
            }

            // Setup options for wysiwyg
            vm.froalaOptions = {
                language: vm.languageLocal.code,
                imageUpload: true,
                imageUploadURL: imageUploadApi,
                imageDeleteConfirmation: false,
                headers: onvioHeaders,
                inlineMode: false,
                spellcheck: true,
                pasteImage: false,
                fullPage: true,
                useClasses: false,
                placeholder: '',
                buttons: [
                    'bold', 'italic', 'underline', 'fontFamily','fontSize', 'color', 'sep', 'formatBlock', 'align',
                    'insertUnorderedList', 'insertOrderedList', 'indent', 'outdent', 'sep', 'createLink', 'insertLinkButton',
                    'insertImage', 'insertHorizontalRule', 'undo', 'redo', 'html'
                ],
                beautifyCode: false,
                allowScript: true,
                minHeight: 150,
                maxHeight: 500,
                tabSpaces: false,
                events: {
                    afterRemoveImage: function(e, editor, img){
                        var src = img.attr('src');
                        var parts = src.split('/');
                        froalaImages.push(parts[parts.length - 1]);
                    },
                    afterImageUpload: function(e, editor, response){
                        if(response.link){
                            var parts = response.link.split('/');
                            froalaImages.push(parts[parts.length - 1]);
                        }
                    }
                }
            };

            init();

            //////////

            function init(){
                // Create method publicly available through 2-way data bound object
                vm.languageLocal.setDirty = function(){
                    setFormState();
                };

                // load up preferences
                $scope.$emit('bm-busy-loading-on');
                stylingManger.getLocalePreferences(vm.environment, vm.languageLocal.code).then(function(results){
                    $scope.$emit('bm-busy-loading-off');
                    vm.displayIsGood = true;

                    // more than one preference?
                    if(angular.isDefined(results) && angular.isDefined(results.defaultPreferences)){
                        vm.defaultPreferences = results.defaultPreferences;
                        setPreferencesDisplay(results.preferences);
                        vm.allowSampleText = vm.environment === 'external' && vm.defaultPreferences.footerText && vm.defaultPreferences.footerText !== '';
                    } else {
                        setPreferencesDisplay(results);
                    }
                }, function(){
                    $scope.$emit('bm-busy-loading-off');
                    $translate('bmt.notifications.styling.loadError').then(function(value){
                        Notifications.setError(value);
                    });
                    setPreferencesDisplay({});
                });
            }

            function setPreferencesDisplay(preferences){
                // make sure locale is set correctly as web service may not return
                preferences.locale = vm.languageLocal.code;
                vm.preferences = new ClientNotificationPreferences(preferences);

                // keep original copy around for comparisons
                currentPreferences = angular.copy(vm.preferences);
            }

            function getFormFieldValidity(){
                // set form as dirty in order to display any validation messages
                vm.stylingSetupForm.$setSubmitted();
                return vm.stylingSetupForm.$valid;
            }

            function saveStyle(){
                resetNotifications();

                // validate that the email address was added correctly
                if(!getFormFieldValidity()){
                    $translate('bmt.common.invalidForm').then(function(value){
                        vm.alerts.push({ msg: value, type: 'danger' });
                    });
                    $scope.$emit('scollViewTop');
                    return;
                }

                savePreferences(angular.copy(vm.preferences));
            }

            function openRestoreStyle(){
                var modalInstance = $uibModal.open({
                    templateUrl: 'components/client-notifications/styling/restore-default-modal.2js.html',
                    controller: 'restoreDefaultStylingCtrl as vm',
                    backdrop: 'static',
                    size: 'sm'
                });

                modalInstance.result.then(function(){
                    savePreferences(angular.copy(vm.defaultPreferences));
                });
            }

            function savePreferences(preferences){
                $scope.$emit('bm-busy-loading-on');
                stylingManger.saveNotificationPreferences(vm.environment, preferences).then(function(){
                    $scope.$emit('bm-busy-loading-off');
                    currentPreferences = preferences;
                    resetStyle();
                }, function(){
                    $scope.$emit('bm-busy-loading-off');
                    $translate('bmt.notifications.styling.saveError').then(function(value){
                        Notifications.setError(value);
                    });
                });
            }

            function cleanImages(preferences){
                if(froalaImages.length === 0){
                    return;
                }

                var filtered = froalaImages.filter(function(element){
                    return (preferences.headerText.indexOf(element) < 0 && preferences.footerText.indexOf(element) < 0);
                });

                if(angular.isDefined(filtered) && filtered.length > 0){
                    var promises = [];
                    angular.forEach(filtered, function(item){
                        promises.push(messageFactory.deleteImage(item, vm.environment));
                    });

                    // not going to handle any errors, just push and go
                    $q.all(promises);
                }

                // reset the list of images
                froalaImages.length = 0;
            }

            function resetStyle(){
                cleanImages(currentPreferences);
                resetNotifications();
                setPreferencesDisplay(currentPreferences);
                vm.stylingSetupForm.$setPristine();
                vm.languageLocal.hasUnsavedChanges = false;
                $scope.$emit('scollViewTop');
            }

            function clearHeaderText(){
                vm.preferences.headerText = '';
                setFormState();
            }

            function clearFooterText(){
                vm.preferences.footerText = '';
                setFormState();
            }

            function setFormState(){
                resetNotifications();
                var isClean = angular.equals(vm.preferences, currentPreferences);

                // TODO: FORM NAME SHOULD BE DYNAMIC HERE
                if(isClean){
                    vm.stylingSetupForm.$setPristine();
                } else {
                    vm.stylingSetupForm.$setDirty();
                }

                vm.languageLocal.hasUnsavedChanges = !isClean;
            }

            function resetNotifications(){
                vm.alerts = [];
                Notifications.setError(null);
                Notifications.setInfo(null);
            }

            function openSampleTextModal(){
                var modalInstance = $uibModal.open({
                    templateUrl: 'components/client-notifications/styling/view-sample-text-modal.2js.html',
                    controller: 'viewSampleTextCtrl as vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        text: function(){
                            return vm.defaultPreferences.footerText;
                        }
                    }
                });

                modalInstance.result.then(function(sampleText){
                    if(angular.isDefined(sampleText) && sampleText !== ''){
                        vm.preferences.footerText = sampleText;
                    }
                });
            }
        };
    }
})(window.angular, window.jQuery);

(function(angular){
    'use strict';

    angular.module('internal.tools.clientNotifications').directive('bmtClientNotificationStyling',
        [
            function(){
                return {
                    restrict: 'E',
                    replace: true,
                    scope: {
                        data: '=',
                        environment: '@'
                    },
                    templateUrl: 'components/client-notifications/styling/styling.2js.html',
                    controller: 'bmtClientNotificationsStyling',
                    controllerAs: 'vm',
                    bindToController: true
                };
            }
        ]
    );
})(window.angular);

(function(angular){
    'use strict';

    angular.module('internal.tools.clientNotifications').controller('restoreDefaultStylingCtrl', restoreDefaults);
    restoreDefaults.$inject = ['$uibModalInstance'];

    function restoreDefaults($uibModalInstance){
        /*jshint validthis:true */
        var vm = this;

        vm.restore = restore;
        vm.closeDefaults = closeDefaults;

        /////////

        function restore(){
            $uibModalInstance.close();
        }

        function closeDefaults(){
            $uibModalInstance.dismiss('close');
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('internal.tools.clientNotifications').controller('viewSampleTextCtrl', viewSampleText);
    viewSampleText.$inject = ['$sce', '$uibModalInstance', 'text'];

    function viewSampleText($sce, $uibModalInstance, text){
        /*jshint validthis:true */
        var vm = this;
        vm.copySample = copySample;
        vm.closeSampleModal = closeSampleModal;

        // make a copy of the original text so $sce does not modify the value
        var sampleHtml = angular.copy(text);
        vm.sampleText = $sce.trustAsHtml(sampleHtml);

        //////////

        function copySample(){
            // return the original text/html
            $uibModalInstance.close(text);
        }

        function closeSampleModal(){
            $uibModalInstance.dismiss('close');
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('internal.tools.clientNotifications').directive('bmtVariablesList', ['$q', '$uibModal', 'Variable', 'messageFactory',
    function($q, $uibModal, Variable, messageFactory){
        return {
            restrict: 'E',
            replace: true,
            scope: {
                data: '=',
                admin: '@'
            },
            templateUrl: 'components/client-notifications/variables/variable-list.2js.html',
            link: function(scope){
                // vm in this case is scope

                scope.isAdminTool = scope.admin === 'true';

                // If the scope is within the admin tool, there is no localType
                if(!scope.isAdminTool) {
                    scope.localType = scope.data;
                }

                scope.openAddVariable = openAddVariable;
                scope.openEditVariable = openEditVariable;
                scope.openDeleteVariable = openDeleteVariable;
                scope.openViewVariable = openViewVariable;
                scope.openViewVariableTemplateAssociations = openViewVariableTemplateAssociations;
                scope.saveType = saveType;
                scope.updateSelected = updateSelected;
                scope.search = search;
                scope.resetAlerts = resetAlerts;

                scope.variableList = [];
                scope.rawVariableList = [];
                scope.selectedVariables = [];
                scope.alerts = [];
                scope.searchText = '';

                loadVariableList();

                function openAddVariable(variable){
                    var completeVariable = new Variable(variable);

                    var modalInstance = $uibModal.open({
                        templateUrl: 'components/client-notifications/variables/add-variable-modal.2js.html',
                        controller: 'addVariableCtrl as vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            variable: function(){
                                return completeVariable;
                            },
                            variableList: function(){
                                return scope.variableList;
                            },
                            type: function(){
                                return scope.localType;
                            }
                        }
                    });

                    modalInstance.result.then(function(savedVariable){
                        addAlert('Variable added', 'success');
                        if(angular.isUndefined(variable)){
                            scope.rawVariableList.push(savedVariable);
                            if(!scope.isAdminTool){
                                savedVariable.selected = true;
                            }
                        } else {
                            variable.code = savedVariable.code;
                            variable.mandatory = savedVariable.mandatory;
                            variable.names = savedVariable.names;
                        }
                        if(!scope.isAdminTool) {
                            selectAssociatedVariables();
                        }
                        refreshGrid();
                    });
                }

                function openDeleteVariable(){
                    if(scope.selectedVariables.length === 0){
                        return;
                    }
                    var modalInstance = $uibModal.open({
                        templateUrl: 'components/client-notifications/variables/delete-variable-modal.2js.html',
                        controller: 'deleteVariableCtrl as vm',
                        backdrop: 'static',
                        size: 'sm',
                        resolve: {
                            selectedVariables: function(){
                                return scope.selectedVariables;
                            }
                        }
                    });

                    modalInstance.result.then(function(){
                        if(scope.isAdminTool){
                            handleVariableDelete();
                        } else {
                            handleTypeVariableDelete();
                        }
                    });
                }

                function openEditVariable(){
                    if(scope.selectedVariables.length !== 1){
                        return;
                    }
                    openAddVariable(scope.selectedVariables[0]);
                }

                function openViewVariable(variableToView){
                    openAddVariable(variableToView);
                }

                function openViewVariableTemplateAssociations(){
                    if(scope.selectedVariables.length !== 1){
                        return;
                    }

                    var variable = scope.selectedVariables[0];

                    $uibModal.open({
                        templateUrl: 'components/client-notifications/variables/variable-template-associations-modal.2js.html',
                        controller: 'variableTemplateAssociationsCtrl as vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            variable: function(){
                                return variable;
                            },
                            variableTemplateAssociations: function(){
                                scope.$emit('bm-busy-loading-on');
                                return messageFactory.getTemplateAssociationsByVariable(variable)
                                .then(function(results){
                                    scope.$emit('bm-busy-loading-off');
                                    return results;
                                });
                            }
                        }
                    });
                }

                function saveType() {
                    scope.localType.variables = scope.selectedVariables;
                    scope.$emit('bm-busy-loading-on');
                    scope.localType.save().then(function(){
                        addAlert('Save successful', 'success');
                        scope.$emit('bm-busy-loading-off');
                    });
                }

                function updateSelected(selectedItem) {
                    var wasSelected = !selectedItem.selected;

                    if(wasSelected) {
                        selectedItem.selected = false;
                        scope.selectedVariables = scope.selectedVariables.filter(function(variable){
                            return variable.id !== selectedItem.id;
                        });
                    } else {
                        selectedItem.selected = true;
                        scope.selectedVariables.push(selectedItem);
                    }
                }

                function loadVariableList() {
                    scope.rawVariableList = [];
                    messageFactory.getAllVariables().then(function(results) {
                        scope.rawVariableList = results.map(function(result) {
                            result.selected = false;
                            return result;
                        });
                        if(!scope.isAdminTool) {
                            selectAssociatedVariables();
                        }
                        sortVariableList();
                        scope.variableList = angular.copy(scope.rawVariableList);
                    });
                }

                function selectAssociatedVariables() {
                    var associatedVariables = scope.localType.variables.map(function(associatedVariable) {
                        return associatedVariable.id;
                    });
                    var alreadySelectedVariables = scope.selectedVariables.map(function(alreadySelectedVariables) {
                        return alreadySelectedVariables.id;
                    });
                    scope.rawVariableList.forEach(function(variable) {
                        if(associatedVariables.indexOf(variable.id) !== -1 && alreadySelectedVariables.indexOf(variable.id) === -1) {
                            variable.selected = true;
                            scope.selectedVariables.push(variable);
                        }
                    });
                }

                function handleVariableDelete(){
                    var promises = [];
                    var index;

                    angular.forEach(scope.selectedVariables, function(rowItem){
                        index = scope.rawVariableList.findIndex(function(variable){
                            return variable.id === rowItem.id;
                        });
                        var toDelete = new Variable(scope.rawVariableList[index]);
                        promises.push(toDelete.delete());
                        scope.rawVariableList.splice(index, 1);
                        refreshGrid();
                    });

                    scope.$emit('bm-busy-loading-on');
                    $q.all(promises).then(function(){
                        addAlert('Deletion Successful', 'success');
                        scope.$emit('bm-busy-loading-off');
                    }, function(){
                        scope.$emit('bm-busy-loading-off');
                    });
                }

                function handleTypeVariableDelete(){
                    // update the type and save the type
                    var filtered = angular.copy(scope.localType.variables);

                    angular.forEach(scope.selectedVariables, function(rowItem){
                        filtered = filtered.filter(function(element){
                            return element.id !== rowItem.id;
                        });
                    });

                    scope.localType.variables = filtered;

                    scope.$emit('bm-busy-loading-on');
                    scope.localType.save().then(function(){
                        scope.$emit('bm-busy-loading-off');

                    }, function(){
                        scope.$emit('bm-busy-loading-off');
                    });
                }

                function search(){
                    if(scope.isAdminTool){
                        clearSelections();
                    }
                    var searchTerm = scope.searchText.toUpperCase();
                    scope.variableList = scope.rawVariableList.filter(function(variable){
                        return variable.code.includes(searchTerm);
                    });
                }

                function refreshGrid() {
                    if(scope.isAdminTool){
                        clearSelections();
                    }
                    scope.searchText = '';
                    sortVariableList();
                    scope.variableList = angular.copy(scope.rawVariableList);
                }

                function clearSelections() {
                    scope.rawVariableList.forEach(function(variable){
                        variable.selected = false;
                    });

                    scope.selectedVariables = [];
                    scope.variableList = angular.copy(scope.rawVariableList);
                }

                function sortVariableList(){
                    scope.selectedVariables.sort(function(a,b){
                        if(a.code > b.code){
                            return 1;
                        } else if(a.code < b.code){
                            return -1;
                        } else {
                            return 0;
                        }
                    });

                    const nonSelected = scope.rawVariableList.filter(function(element){
                        var isSelected = scope.selectedVariables.find(function(selectedVar){
                            return selectedVar.id === element.id;
                        });

                        if(isSelected){
                            return false;
                        }

                        return true;
                    });

                    nonSelected.sort(function(a, b){
                        if(a.code > b.code){
                            return 1;
                        } else if(a.code < b.code){
                            return -1;
                        } else {
                            return 0;
                        }
                    });
                    scope.rawVariableList = angular.copy(scope.selectedVariables.concat(nonSelected));
                }

                function addAlert(message, type){
                    resetAlerts();
                    scope.alerts.push({ msg: message, type: type });
                }

                function resetAlerts(){
                    scope.alerts = [];
                }
            }
        };
    }]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('internal.tools.clientNotifications').controller('addVariableCtrl', addVariable);
    addVariable.$inject = ['$rootScope', '$translate', '$uibModalInstance','$location', 'variable','variableList',
    'type'];

    function addVariable($rootScope, $translate, $uibModalInstance, $location, variable, variableList, type){
        /*jshint validthis:true */
        var vm = this;

        vm.isAdminTool = $location.url() === '/variables';
        vm.alerts = [];
        vm.updateType = updateType;
        vm.closeAddModal = closeAddModal;
        vm.resetAlerts = resetAlerts;

        // local copy of provider values
        vm.localVariable = angular.copy(variable);
        vm.localType = type;

        if(angular.isUndefined(vm.localVariable.id)){
            $translate('bmt.common.addLabel').then(function(value){
                vm.actionVerb = value;
                vm.isViewOnly = false;
            });
        } else if(vm.isAdminTool) {
            $translate('bmt.common.editLabel').then(function(value){
                vm.actionVerb = value;
                vm.isViewOnly = false;
            });
        } else {
            $translate('bmt.common.viewLabel').then(function(value){
                vm.actionVerb = value;
                vm.isViewOnly = true;
            });
        }

        /////////

        function updateType(){
            resetAlerts();

            if(vm.addVariableForm.$invalid){
                $translate('bmt.common.invalidForm').then(function(value){
                    addAlert(value, 'danger');
                });
            } else {
                var variableToSave = angular.copy(vm.localVariable);
                variableToSave.code = variableToSave.code.trim().toUpperCase();
                if(angular.isUndefined(variable.code) && !isUniqueIdentifier(variableToSave.code)) {
                    addAlert('A variable with that identifier already exists', 'danger');
                } else {
                    if(vm.isAdminTool){
                        handleVariableUpdate(variableToSave);
                    } else {
                        handleNotificationUpdate(variableToSave);
                    }
                }
            }
        }

        function handleVariableUpdate(variable){
            $rootScope.$emit('bm-busy-loading-on');
            variable.save().then(function(savedVariable){
                $rootScope.$emit('bm-busy-loading-off');
                $uibModalInstance.close(savedVariable);
            }, function(){
                $rootScope.$emit('bm-busy-loading-off');
                $translate('bmt.notifications.variables.saveVariableError').then(function(value){
                    addAlert(value, 'danger');
                });
            });
        }

        function handleNotificationUpdate(variable){
            var handled = false;

            //Look up by id
            if(!angular.isUndefined(variable.id)){
                for(var idx1 = 0; idx1 < vm.localType.variables.length; idx1++){
                    if(vm.localType.variables[idx1].id === variable.id){
                        vm.localType.variables[idx1] = variable;
                        handled = true;
                        break;
                    }
                }
            }

            // Look up by code
            if(!handled && !angular.isUndefined(variable.code)){
                for(var idx2 = 0; idx2 < vm.localType.variables.length; idx2++){
                    if(vm.localType.variables[idx2].code === variable.code){
                        vm.localType.variables[idx2] = variable;
                        handled = true;
                        break;
                    }
                }
            }

            // Add as a new variable
            if(!handled){
                vm.localType.variables.push(variable);
            }

            $rootScope.$emit('bm-busy-loading-on');
            vm.localType.save().then(function(){
                $rootScope.$emit('bm-busy-loading-off');
                // type will be updated with variables and ids
                // return the variable with id
                var filtered = vm.localType.variables.filter(function(element){
                    return element.code === variable.code;
                });

                $uibModalInstance.close(filtered[0]);
            }, function(){
                $rootScope.$emit('bm-busy-loading-off');
                $translate('bmt.notifications.type.saveVariableError').then(function(value){
                    addAlert(value, 'danger');
                });
            });
        }

        function closeAddModal(){
            $uibModalInstance.dismiss('close');
        }

        function isUniqueIdentifier(identifier) {
            return variableList.filter(function(existingVariable) {
                return existingVariable.code === identifier;
            }).length < 1;
        }

        function addAlert(message, type){
            resetAlerts();
            vm.alerts.push({ msg: message, type: type });
        }

        function resetAlerts(){
            vm.alerts.length = 0;
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('internal.tools.clientNotifications').controller('deleteVariableCtrl', deleteVariableCtrl);
    deleteVariableCtrl.$inject = ['$uibModalInstance', 'selectedVariables'];

    function deleteVariableCtrl($uibModalInstance, selectedVariables){
        /*jshint validthis:true */
        var vm = this;

        vm.deleteVariable = deleteVariable;
        vm.closeVariable = closeVariable;
        vm.variablesToDelete = selectedVariables;

        /////////

        function deleteVariable(){
            $uibModalInstance.close();
        }

        function closeVariable(){
            $uibModalInstance.dismiss('close');
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('internal.tools.clientNotifications').controller('maintainVariablesCtrl', maintainVariables);
    maintainVariables.$inject = ['$uibModalInstance', 'NotificationType', 'type', 'categoryId'];

    function maintainVariables($uibModalInstance, NotificationType, type, categoryId){
        /*jshint validthis:true */
        var vm = this;

        vm.closeModal = closeModal;

        // local copy of provider values
        vm.localType = new NotificationType(type, categoryId);

        /////////

        function closeModal(){
            var variables = (angular.isDefined(vm.localType) && angular.isDefined(vm.localType.variables)) ? vm.localType.variables : [];
            $uibModalInstance.close(variables);
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('internal.tools.clientNotifications').controller('variableTemplateAssociationsCtrl', variableTemplateAssociationsCtrl);
    variableTemplateAssociationsCtrl.$inject = ['$uibModalInstance', 'variable', 'variableTemplateAssociations'];

    function variableTemplateAssociationsCtrl($uibModalInstance, variable, variableTemplateAssociations){
        /*jshint validthis:true */
        var vm = this;

        vm.variable = variable;
        vm.variableTemplateAssociations = variableTemplateAssociations;
        vm.closeModal = closeModal;

        function closeModal(){
            $uibModalInstance.close();
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('internal.tools.clientNotifications').directive('bmtLocaleNames', [function(){
        return {
            restrict: 'E',
            replace: true,
            scope: {
                data: '=',
                isViewOnly: '='
            },
            templateUrl: 'components/client-notifications/locale-names/locale-names.2js.html',
            link: function(scope){
                scope.localData = scope.data;
            }
        };
    }]);
})(window.angular);

angular.module('internal.tools.clientNotifications.templates', ['components/client-notifications/locale-names/locale-names.2js.html', 'components/client-notifications/styling/restore-default-modal.2js.html', 'components/client-notifications/styling/styling.2js.html', 'components/client-notifications/styling/view-sample-text-modal.2js.html', 'components/client-notifications/variables/add-variable-modal.2js.html', 'components/client-notifications/variables/delete-variable-modal.2js.html', 'components/client-notifications/variables/maintain-variables-modal.2js.html', 'components/client-notifications/variables/variable-list.2js.html', 'components/client-notifications/variables/variable-template-associations-modal.2js.html', 'components/templates/bento-alert-custom.2js.html', 'components/templates/new-bento-alert-custom.2js.html']);

angular.module("components/client-notifications/locale-names/locale-names.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/client-notifications/locale-names/locale-names.2js.html",
    "<div>\n" +
    "    <div class=\"row bmt-row-inline-header\">\n" +
    "        <div class=\"col-sm-12\" translate>\n" +
    "            bmt.category.localeDisplayLabel\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-repeat=\"localizedName in localData.names\">\n" +
    "        <span class=\"bmt-row-inline-header\">{{localizedName.locale}}:</span>\n" +
    "        <!-- display name -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-sm-12\">\n" +
    "                <div class=\"form-group\">\n" +
    "                    <label for=\"localeDisplay{{localizedName.locale}}\" translate>bmt.common.nameLabel</label>\n" +
    "                    <input ng-disabled=\"isViewOnly\" type=\"text\" name=\"localeDisplay{{localizedName.locale}}\" id=\"localeDisplay{{localizedName.locale}}\" class=\"form-control\" ng-model=\"localizedName.name\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <!-- description -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-sm-12\">\n" +
    "                <div class=\"form-group\">\n" +
    "                    <label for=\"desc{{localizedName.locale}}\" translate>bmt.common.descriptionLabel</label>\n" +
    "                    <input ng-disabled=\"isViewOnly\" type=\"text\" name=\"desc{{localizedName.locale}}\" id=\"desc{{localizedName.locale}}\" class=\"form-control\" ng-model=\"localizedName.description\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/client-notifications/styling/restore-default-modal.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/client-notifications/styling/restore-default-modal.2js.html",
    "<div class=\"bento-modal\">\n" +
    "    <div class=\"modal-body modal-confirm-body\">\n" +
    "        <i class=\"bento-icon-warning modal-confirm-icon\"></i>\n" +
    "        <span class=\"modal-confirm-message\" translate>\n" +
    "            bmt.notifications.styling.restoreDefaultText\n" +
    "        </span>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button class=\"btn btn-primary btn-md btn-dynamic\" ng-click=\"vm.restore()\" translate>\n" +
    "            bmt.common.confirm\n" +
    "        </button>\n" +
    "        <button class=\"btn btn-default btn-md btn-dynamic\" ng-click=\"vm.closeDefaults()\" translate>\n" +
    "            bmt.common.cancel\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/client-notifications/styling/styling.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/client-notifications/styling/styling.2js.html",
    "<form id=\"form_{{vm.languageLocal.code}}\" role=\"form\" name=\"vm.stylingSetupForm\" novalidate=\"\" class=\"css-form\">\n" +
    "    <fieldset>\n" +
    "        <!-- alert display -->\n" +
    "        <div class=\"row\" ng-if=\"vm.alerts.length > 0\">\n" +
    "            <div class=\"col-sm-8\">\n" +
    "                <div class=\"bento-alert-container\" ng-if=\"vm.alerts.length > 0\">\n" +
    "                    <uib-alert template-url=\"components/templates/bento-alert-custom.2js.html\" ng-repeat=\"alert in vm.alerts\" type=\"{{alert.type}}\">\n" +
    "                        {{alert.msg}}\n" +
    "                    </uib-alert>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <h3 class=\"bmt-no-top-margin\" translate>bmt.notifications.globalAddressesTitle</h3>\n" +
    "        <!-- sender name -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-sm-6 form-group\">\n" +
    "                <label for=\"senderName\" translate>bmt.notifications.senderNameLabel</label>\n" +
    "                <input id=\"senderName\" name=\"senderName\" class=\"form-control\" type=\"text\" ng-model=\"vm.preferences.senderName\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <!-- sender email -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-sm-6\">\n" +
    "                <div class=\"form-group\" ng-class=\"{'has-error' : vm.stylingSetupForm.senderEmail.$invalid && ((vm.stylingSetupForm.senderEmail.$touched && vm.stylingSetupForm.senderEmail.$dirty) || vm.stylingSetupForm.$submitted)}\">\n" +
    "                    <label for=\"senderEmail\" translate>bmt.notifications.senderEmailLabel</label>\n" +
    "                    <input id=\"senderEmail\" name=\"senderEmail\" class=\"form-control\" type=\"text\" ng-model=\"vm.preferences.senderEmail\" ng-model-options=\"{ debounce: 500, blur: 0 }\" sender-email-validator />\n" +
    "                    <div class=\"msg\" ng-messages=\"vm.stylingSetupForm.senderEmail.$error\" ng-if=\"vm.stylingSetupForm.senderEmail.$touched || vm.stylingSetupForm.$submitted\">\n" +
    "                        <span ng-message=\"senderEmail\">{{'bmt.notifications.validators.senderEmail' | translate}}</span>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <!-- cc email -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-sm-8 form-group\">\n" +
    "                <label for=\"ccEmail\" translate>bmt.notifications.emailCcLabel</label>\n" +
    "                <textarea id=\"ccEmail\" name=\"ccEmail\" ng-model=\"vm.preferences.cc\" class=\"form-control\" bmt-email-list-formatter></textarea>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <!-- bcc email  -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-sm-8 form-group\">\n" +
    "                <label for=\"bccEmail\" translate>bmt.notifications.emailBccLabel</label>\n" +
    "                <textarea id=\"bccEmail\" name=\"bccEmail\" ng-model=\"vm.preferences.bcc\" class=\"form-control\" bmt-email-list-formatter></textarea>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <h3 translate>bmt.notifications.headerFooterTitle</h3>\n" +
    "        <!-- header text -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-sm-10 form-group\">\n" +
    "                <label for=\"headerTextArea\" translate>bmt.common.titles.header</label>\n" +
    "                <div id=\"headerText_{{vm.languageLocal.code}}_froala\" class=\"form-group\">\n" +
    "                    <textarea class=\"form-control\" name=\"headerTextArea\" id=\"headerTextArea\" froala=\"vm.froalaOptions\" ng-model=\"vm.preferences.headerText\"></textarea>\n" +
    "                </div>\n" +
    "                <div class=\"form-group\">\n" +
    "                    <button class=\"btn btn-md btn-default\" ng-click=\"vm.clearHeaderText()\" translate>\n" +
    "                        bmt.notifications.styling.clearText\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <!-- footer text -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-sm-10 form-group bmt-no-bottom-margin\">\n" +
    "                <label for=\"footerTextArea\" translate>bmt.common.titles.footer</label>\n" +
    "                <div id=\"footerText_{{vm.languageLocal.code}}_froala\" class=\"form-group\">\n" +
    "                    <textarea class=\"form-control\" name=\"footerTextArea\" id=\"footerTextArea\" froala=\"vm.froalaOptions\" ng-model=\"vm.preferences.footerText\"></textarea>\n" +
    "                </div>\n" +
    "                <div class=\"form-group clearfix\">\n" +
    "                    <button class=\"btn btn-md btn-default\" ng-click=\"vm.clearFooterText()\" translate>\n" +
    "                        bmt.notifications.styling.clearText\n" +
    "                    </button>\n" +
    "                    <a role=\"button\" href=\"\" ng-click=\"vm.openSampleTextModal()\" class=\"btn btn-link\" ng-if=\"vm.allowSampleText\" translate>bmt.common.viewSampleText</a>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </fieldset>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "            <hr class=\"section-divider\" />\n" +
    "            <button class=\"btn btn-md btn-primary\" ng-click=\"vm.saveStyle()\" translate>\n" +
    "                bmt.notifications.styling.saveStyle\n" +
    "            </button>\n" +
    "            <button class=\"btn btn-md btn-default\" ng-click=\"vm.openRestoreStyle()\" ng-if=\"vm.environment !== 'internal' && vm.defaultPreferences\" translate>\n" +
    "                bmt.notifications.styling.restoreDefaultButton\n" +
    "            </button>\n" +
    "            <button class=\"btn btn-md btn-default\" ng-click=\"vm.resetStyle()\" translate>\n" +
    "                bmt.common.cancel\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("components/client-notifications/styling/view-sample-text-modal.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/client-notifications/styling/view-sample-text-modal.2js.html",
    "<div\n" +
    "    class=\"bento-modal bmt-modal\"\n" +
    "    role=\"dialog\"\n" +
    "    aria-modal=\"true\"\n" +
    "    aria-labelledby=\"ampleText-modal-label\"\n" +
    "    aria-describedby=\"sampleText-modal-desc\">\n" +
    "    <button type=\"button\" class=\"close\" aria-label=\"{{ 'bmt.notifications.closeDialog' | translate }}\" ng-click=\"vm.closeSampleModal()\">\n" +
    "      <i aria-hidden=\"true\" class=\"bento-icon-close-x\"></i>\n" +
    "    </button>\n" +
    "    <H2 class=\"modal-header\" id=\"sampleText-modal-label\" translate>\n" +
    "        bmt.notifications.sampleFooterTitle\n" +
    "    </H2>\n" +
    "    <div class=\"modal-body\" id=\"sampleText-modal-desc\">\n" +
    "        <span translate>\n" +
    "            bmt.common.sampleTextInstructions\n" +
    "        </span>\n" +
    "        <hr class=\"section-divider\" />\n" +
    "        <div class=\"sample-view\" ng-bind-html=\"vm.sampleText\"></div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button type=\"button\" class=\"btn btn-primary btn-dynamic\" ng-click=\"vm.copySample()\" translate>\n" +
    "            bmt.common.copyToEditor\n" +
    "        </button>\n" +
    "        <button type=\"button\" class=\"btn btn-default btn-dynamic\" ng-click=\"vm.closeSampleModal()\" translate>\n" +
    "            bmt.common.cancel\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/client-notifications/variables/add-variable-modal.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/client-notifications/variables/add-variable-modal.2js.html",
    "<form name=\"vm.addVariableForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "    <div class=\"bento-modal\">\n" +
    "        <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.closeAddModal()\">\n" +
    "            <i class=\"bento-icon-close-x\"></i>\n" +
    "        </button>\n" +
    "        <div class=\"modal-header\">\n" +
    "            {{vm.actionVerb}} <span translate>bmt.notifications.type.customVariable</span>\n" +
    "        </div>\n" +
    "        <div class=\"modal-body\">\n" +
    "            <div class=\"bento-alert-container\" ng-if=\"vm.alerts.length > 0\">\n" +
    "                <div uib-alert template-url=\"components/templates/new-bento-alert-custom.2js.html\" ng-repeat=\"alert in vm.alerts\" ng-class=\"'alert-' + (alert.type || 'warning')\" close=\"vm.resetAlerts()\">\n" +
    "                    {{alert.msg}}\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\" ng-if=\"vm.localDisplay === 'notification'\">\n" +
    "                <div class=\"col-sm-12 bmt-form-title\">\n" +
    "                    <span translate>bmt.notifications.typeTitle</span>: {{vm.localType.code}}\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-sm-8\">\n" +
    "                    <div class=\"form-group bmt-no-bottom-margin\" ng-class=\"{'has-error' : vm.addVariableForm.code.$invalid && ((vm.addVariableForm.code.$touched && vm.addVariableForm.code.$dirty) || vm.addVariableForm.$submitted)}\">\n" +
    "                        <label for=\"code\"><span translate>bmt.common.identifierLabel</span> *</label>\n" +
    "                        <input id=\"code\" style='text-transform:uppercase' name=\"code\" class=\"form-control\" type=\"text\" ng-model=\"vm.localVariable.code\" bm-focus=\"true\" ng-disabled=\"vm.localVariable.id !== undefined && vm.localVariable.id !== ''\" required />\n" +
    "                        <div class=\"msg\" ng-messages=\"vm.addVariableForm.code.$error\" ng-if=\"vm.addVariableForm.code.$touched || vm.addVariableForm.$submitted\">\n" +
    "                            <span ng-message=\"required\">{{ 'bmt.notifications.type.variable.identifierRequiredError' | translate }}</span>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-sm-4 form-group\">\n" +
    "                    <div class=\"checkbox\">\n" +
    "                        <label>\n" +
    "                            <input ng-disabled=\"vm.isViewOnly\" type=\"checkbox\" ng-model=\"vm.localVariable.mandatory\" ng-true-value=\"true\" ng-false-value=\"false\"> <span translate>bmt.notifications.type.mandatoryLabel</span>\n" +
    "                        </label>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <!-- language display names -->\n" +
    "            <bmt-locale-names is-view-only=\"vm.isViewOnly\" data=\"vm.localVariable\"></bmt-locale-names>\n" +
    "            <div class=\"bmt-required\">\n" +
    "                * <span translate>bmt.common.requiredField</span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"modal-footer\">\n" +
    "            <button ng-if=\"!vm.isViewOnly\" type=\"submit\" role=\"button\" class=\"btn btn-md btn-primary\" ng-click=\"vm.updateType()\" translate>\n" +
    "                bmt.notifications.type.variable.saveButton\n" +
    "            </button>\n" +
    "            <button ng-if=\"!vm.isViewOnly\" class=\"btn btn-md btn-default\" ng-click=\"vm.closeAddModal()\" translate>\n" +
    "                bmt.common.cancel\n" +
    "            </button>\n" +
    "            <button ng-if=\"vm.isViewOnly\" class=\"btn btn-md btn-default\" ng-click=\"vm.closeAddModal()\" translate>\n" +
    "                bmt.common.close\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("components/client-notifications/variables/delete-variable-modal.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/client-notifications/variables/delete-variable-modal.2js.html",
    "<div class=\"bento-modal\">\n" +
    "    <div class=\"modal-body modal-confirm-body\">\n" +
    "        <i class=\"bento-icon-warning modal-confirm-icon\"></i>\n" +
    "        <span class=\"modal-confirm-message\" translate>\n" +
    "            bmt.notifications.type.variable.deleteConfirmText\n" +
    "        </span>\n" +
    "    </div>\n" +
    "    <div>\n" +
    "        <ul>\n" +
    "            <li ng-repeat=\"variable in vm.variablesToDelete\">{{variable.code}}</li>\n" +
    "        </ul>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button class=\"btn btn-primary\" ng-click=\"vm.deleteVariable()\" translate>\n" +
    "            bmt.common.confirm\n" +
    "        </button>\n" +
    "        <button class=\"btn btn-default\" ng-click=\"vm.closeVariable()\" translate>\n" +
    "            bmt.common.cancel\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/client-notifications/variables/maintain-variables-modal.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/client-notifications/variables/maintain-variables-modal.2js.html",
    "<div class=\"bento-modal\">\n" +
    "    <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.closeModal()\">\n" +
    "      <i class=\"bento-icon-close-x\"></i>\n" +
    "    </button>\n" +
    "    <div class=\"modal-header\" translate>\n" +
    "        bmt.notifications.type.variable.maintainHeader\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"bmt-form-title\">\n" +
    "            <span translate>bmt.notifications.typeTitle</span>: {{vm.localType.code}}\n" +
    "        </div>\n" +
    "        <bmt-variables-list data=\"vm.localType\" admin=\"false\"></bmt-variables-list>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/client-notifications/variables/variable-list.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/client-notifications/variables/variable-list.2js.html",
    "<div>\n" +
    "    <div class=\"bento-alert-container\" ng-if=\"alerts.length > 0\">\n" +
    "        <div uib-alert template-url=\"components/templates/new-bento-alert-custom.2js.html\" ng-repeat=\"alert in alerts\" ng-class=\"'alert-' + (alert.type || 'warning')\" close=\"resetAlerts()\">\n" +
    "            {{alert.msg}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div bento-nav-toolbar class=\"navbar navbar-default bento-toolbar\" aria-controls=\"variablesTable\">\n" +
    "        <ul class=\"nav navbar-nav\">\n" +
    "            <li>\n" +
    "                <a ng-href=\"\" ng-click=\"openAddVariable()\"><i class=\"bento-icon-add\"></i><span translate>bmt.common.addLabel</span></a>\n" +
    "            </li>\n" +
    "            <li ng-if=\"isAdminTool\" ng-disabled=\"selectedVariables.length !== 1\">\n" +
    "                <a ng-href=\"\" ng-click=\"openEditVariable()\" ><i class=\"bento-icon-edit\"></i><span translate>bmt.common.editLabel</span></a>\n" +
    "            </li>\n" +
    "            <li ng-if=\"isAdminTool\" ng-disabled=\"selectedVariables.length !== 1\">\n" +
    "                <a ng-href=\"\" ng-click=\"openViewVariableTemplateAssociations()\"><i class=\"bento-icon-eye\"></i><span translate>bmt.notifications.variables.viewTemplateAssociations</span></a>\n" +
    "            </li>\n" +
    "            <li ng-if=\"isAdminTool\" ng-disabled=\"selectedVariables.length < 1\">\n" +
    "                <a ng-href=\"\" ng-click=\"openDeleteVariable()\" ><i class=\"bento-icon-close-circle\"></i><span translate>bmt.common.deleteLabel</span></a>\n" +
    "            </li>\n" +
    "            <li ng-if=\"!isAdminTool\">\n" +
    "                <a ng-click=\"saveType()\" ><i class=\"bento-icon-save-solid\"></i><span translate>bmt.common.save</span></a>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "        <div id=\"variableListSearchBox\" class=\"pull-right col-md-4\">\n" +
    "                <input type=\"text\" class=\"form-control\" placeholder=\"Search\" data-ng-model=\"searchText\" ng-change=\"search()\">\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <wj-flex-grid control=\"flexgrid\" items-source=\"variableList\" id=\"variableListGrid\">\n" +
    "            <wj-flex-grid-cell-template cell-type=\"RowHeader\">\n" +
    "                    <input type=\"checkbox\" ng-model=\"$item.selected\" ng-click=\"updateSelected($item)\">\n" +
    "                </wj-flex-grid-cell-template>\n" +
    "            <wj-flex-grid-column  header=\"Identifier\" binding=\"code\" width=\"*\"  is-read-only=\"true\">\n" +
    "                    <span style=\"padding-left: 0;\" class=\"btn btn-link\" ng-click=\"openViewVariable($item)\">{{$item.code}}</span>\n" +
    "            </wj-flex-grid-column>\n" +
    "    </wj-flex-grid>\n" +
    "    <p class=\"bmoon-grid-style bmoon-grid-actions-included text-warning\" ng-if=\"!variableList || variableList.length === 0\" translate>\n" +
    "        bmt.notifications.type.variable.noVariablesDefined\n" +
    "    </p>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/client-notifications/variables/variable-template-associations-modal.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/client-notifications/variables/variable-template-associations-modal.2js.html",
    "<div class=\"bento-modal\">\n" +
    "    <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.closeModal()\">\n" +
    "      <i class=\"bento-icon-close-x\"></i>\n" +
    "    </button>\n" +
    "    <div class=\"modal-header\">\n" +
    "            Templates Associated with {{vm.variable.code}}:\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <wj-flex-grid control=\"flexgrid\" items-source=\"vm.variableTemplateAssociations\">\n" +
    "            <wj-flex-grid-column width=\"*\" header=\"Category\" binding=\"type.categoryCode\" is-read-only=\"true\"></wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column width=\"*\" header=\"Identifier\" binding=\"type.code\" is-read-only=\"true\"></wj-flex-grid-column>\n" +
    "    </wj-flex-grid>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/templates/bento-alert-custom.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/templates/bento-alert-custom.2js.html",
    "<div class=\"alert bento-alert\" ng-class=\"['alert-' + (type || 'warning'), closeable ? 'alert-dismissable' : null]\" role=\"alert\">\n" +
    "    <button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close()\">\n" +
    "        <span aria-hidden=\"true\"><i class=\"bento-icon-close-x\"></i></span>\n" +
    "        <span class=\"sr-only\">Close</span>\n" +
    "    </button>\n" +
    "    <div ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/templates/new-bento-alert-custom.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/templates/new-bento-alert-custom.2js.html",
    "<!-- TODO: SCOPE VARIABLE DOESN\"T WORK HERE SO CLOSEABLE AND TYPE AREN'T SUPPORTED -->\n" +
    "<!-- SHOULD SWITCH TO NOT USING INLINE ALERTS OR INVESTIGATE SCOPE ISSUES -->\n" +
    "<button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" +
    "    <span aria-hidden=\"true\"><i class=\"bento-icon-close-x\"></i></span>\n" +
    "    <span class=\"sr-only\">Close</span>\n" +
    "</button>\n" +
    "<div ng-transclude></div>");
}]);

/**
 * This file is used to re-add the angularJS wijmo properties to the window after the Angular 6 scripts overwrite them.
 * This file can be deleted after a full migration to Angular
 */

var wijmoJS = window.wijmo;

window['combineWijmo'] = function() {
    window.wijmo['input'] = wijmoJS.input;
    window.wijmo['collections'] = wijmoJS.collections;
    window.wijmo['grid'] = wijmoJS.grid;
    wijmo.setLicenseKey('TR,491965575532338#B0nagFDZDtUaLlDOvBFZ8VGNqhlWj56ZnN7UvdmRnh4a9FUShZWRml4Un5kbSRTNylmau56d7YFby2icYFXa0FlaupWYGxEa4EmQKBXROtkdzRDR5UjMpNTSsNDWyMnZoN6UjFWQkVETSJmeLBFd4djWql7aMZFRG94UUBlWNp5U8Y5aLRkYEh6axU5ZwtGWMtWVL3SWtFGVyAzQR3SW8lTa7VDWLJkNpxkTQlWSpdEc8ZlY9VDWWhkQOpWaHpHUmNTZZljQ9h7d8lGZMFEVyNUZj3iYHlURJVWaPRleMNjQwhlYCNlcJJmYhJ7Y9BTc9A5QyUzQyFzcO9GT4YTdtJEcnJUSINkUPFjWM5EaIdlSn3kc7E6Z9cUMVxUaYJVNxk7M42id09UVkhDbllXWTJTWBJmSQdjU4lUbpJ7coNkWUR7VrtmMFdWe7RWVwZmNotGVSlkI0IyUiwiI6QUMwIkRBdjI0ICSiwiM4IDN4IzM8kTM0IicfJye35XX3JSSwIjUiojIDJCLi86bpNnblRHeFBCI4VWZoNFelxmRg2Wbql6ViojIOJyes4nI5kkTRJiOiMkIsIibvl6cuVGd8VEIgIXZ7VWaWRncvBXZSBybtpWaXJiOi8kI1xSfis4N8gkI0IyQiwiIu3Waz9WZ4hXRgAydvJVa4xWdNBybtpWaXJiOi8kI1xSfiQjR6QkI0IyQiwiIu3Waz9WZ4hXRgACUBx4TgAybtpWaXJiOi8kI1xSfiMzQwIkI0IyQiwiIlJ7bDBybtpWaXJiOi8kI1xSfiUFO7EkI0IyQiwiIu3Waz9WZ4hXRgACdyFGaDxWYpNmbh9WaGBybtpWaXJiOi8kI1tlOiQmcQJCLigDN8EzNwAiNwEDMxIDMyIiOiQncDJCLiIFViojIh94QiwiI8MzMyMTN5cTN5YTOxkDNiojIklkIs4nIzYHMyAjMiojIyVmdiwSZzxWYmpjIyNHZisnOiwmbBJye0ICRiwiI34pZZd');
}
